module.exports = __webpack_public_path__ + "static/media/ir.c01bf3bd.svg";